'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { StepperMinusIconS } from '@lichtblick/icons/svg/stepper-minus/stepper-minus-s';
import { StepperPlusIconS } from '@lichtblick/icons/svg/stepper-plus/stepper-plus-s';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Textfield } from '../textfield';
import styles from './stepper.module.scss';
export const Stepper = ({ onChange, ...props })=>{
    const ref = useRef(null);
    const { max, min, value } = props;
    const maxValue = max ? Number(max) : Number.MAX_VALUE;
    const minValue = min ? Number(min) : Number.MIN_VALUE;
    const [isSmallerThanMin, setIsSmallerThanMin] = useState(Number(value) <= minValue);
    const [isGreaterThanMax, setIsGreaterThanMax] = useState(Number(value) >= maxValue);
    const checkValidity = useCallback(()=>{
        if (ref.current) {
            const currentValue = Number(ref.current.value ?? value);
            setIsSmallerThanMin(currentValue <= minValue);
            setIsGreaterThanMax(currentValue >= maxValue);
        }
    }, [
        maxValue,
        minValue,
        value
    ]);
    const handleChange = useCallback(()=>{
        setIsSmallerThanMin(Number(ref.current?.value) <= minValue);
        setIsGreaterThanMax(Number(ref.current?.value) >= maxValue);
        onChange?.(Number(ref.current?.value));
    }, [
        maxValue,
        minValue,
        onChange
    ]);
    const handleFocus = useCallback((e)=>{
        e.preventDefault();
        e.currentTarget.blur();
    }, []);
    useEffect(()=>{
        checkValidity();
    }, [
        checkValidity
    ]);
    return /*#__PURE__*/ _jsx(Textfield, {
        ...props,
        centered: true,
        className: classNames(styles.stepper, props.className),
        inputClassName: styles.input,
        inputMode: "numeric",
        leftSlot: /*#__PURE__*/ _jsx("button", {
            "aria-hidden": true,
            className: styles.button,
            disabled: props.disabled || props.readOnly || isSmallerThanMin,
            onClick: ()=>{
                ref.current?.stepDown();
                handleChange();
            },
            onFocus: handleFocus,
            tabIndex: -1,
            type: "button",
            children: /*#__PURE__*/ _jsx(StepperMinusIconS, {
                className: styles.icon
            })
        }),
        onChange: handleChange,
        onInvalid: (e)=>{
            e.preventDefault();
            e.currentTarget.focus();
        },
        ref: ref,
        rightSlot: /*#__PURE__*/ _jsx("button", {
            "aria-hidden": true,
            className: styles.button,
            disabled: props.disabled || props.readOnly || isGreaterThanMax,
            onClick: ()=>{
                ref.current?.stepUp();
                handleChange();
            },
            onFocus: handleFocus,
            tabIndex: -1,
            type: "button",
            children: /*#__PURE__*/ _jsx(StepperPlusIconS, {
                className: styles.icon
            })
        }),
        type: "number"
    });
};

//# sourceMappingURL=index.js.map